export enum PatientType {
  TINYMEDIC = 'TINYMEDIC',

  OP = 'OP',

  EMERGENCY_OP = 'EMERGENCY_OP',

  IP = 'IP',

  PROCEDURE = 'PROCEDURE',
}
